import { render, staticRenderFns } from "./footerBottom.vue?vue&type=template&id=9cb5e1f8&scoped=true&"
import script from "./footerBottom.vue?vue&type=script&lang=js&"
export * from "./footerBottom.vue?vue&type=script&lang=js&"
import style0 from "./footerBottom.vue?vue&type=style&index=0&id=9cb5e1f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cb5e1f8",
  null
  
)

export default component.exports